import styles from "./project-preview.module.css";
import { ProjectTemplate } from "PosterEditor/model/project-template";
import { PosterProject } from "PosterEditor/model/poster-project";
import { useProjectThumbnail } from "./use-project-thumbnail";
import { Size } from "PosterEditor/model/poster-types";
import { filterClasses } from "PosterEditor/utils/filter-classes";

interface ProjectPreviewProps {
  template?: ProjectTemplate;
  project?: PosterProject;
  size?: Size;
  showOutline?: boolean;
  allowHoverEffect?: boolean;
  showShadow?: boolean;
  className?: string;
}

export const ProjectPreview = ({
  template,
  project,
  size,
  showOutline = false,
  showShadow = true,
  allowHoverEffect = false,
  className,
}: ProjectPreviewProps) => {
  const { image, size: resolvedSize } = useProjectThumbnail({
    template: template,
    project: project,
    size: size ?? { width: 140, height: 140 },
  });

  if (size) {
    return (
      <img
        className={filterClasses(
          styles.previewImage,
          showOutline ? styles.outline : "",
          allowHoverEffect ? styles.hoverEffect : styles.noHoverEffect,
          showShadow ? "" : styles.noShadow,
          className
        )}
        style={{
          height: resolvedSize.height,
          width: resolvedSize.width,
          objectFit: "contain",
        }}
        src={image}
        alt={template?.name ?? project?.name ?? "Project Preview"}
      />
    );
  }
  return (
    <img
      className={filterClasses(
        styles.previewImage,
        showOutline ? styles.outline : "",
        allowHoverEffect ? styles.hoverEffect : styles.noHoverEffect,
        showShadow ? "" : styles.noShadow,
        className
      )}
      src={image}
      alt={template?.name ?? project?.name ?? "Project Preview"}
    />
  );
};
